import { createFileRoute, redirect } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

// The imprint moved to the legal page (DNI-857); keep the old URL working.
export const Route = createFileRoute('/(main)/settings/imprint/')({
  beforeLoad: () => {
    throw redirect({
      replace: true,
      search: { tab: 'imprint' },
      to: '/legal',
    });
  },
});

export const SETTINGS_IMPRINT = buildRouteExport({
  Route,
});
